import thunk from 'redux-thunk';
import { IApplicationState } from './models/ApplicationState';
import {
    combineReducers,
    createStore,
    compose,
    applyMiddleware,
} from 'redux';
import { reducers } from './reducers';

export default function configureStore(initialState?: IApplicationState) {
    const middleware = [thunk];

    const rootReducer = combineReducers({
        ...reducers,
    });

    const enhancers = [];

    const windowIfDefined = typeof window === 'undefined' ?
        null :
        (window as any);

    if (windowIfDefined && windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        enhancers.push(windowIfDefined.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__());
    }

    return createStore(
        rootReducer,
        initialState,
        compose(applyMiddleware(...middleware), ...enhancers));
}
